import { render, staticRenderFns } from "./ModalAddSaillieBeta.vue?vue&type=template&id=4295ead7&"
import script from "./ModalAddSaillieBeta.vue?vue&type=script&lang=js&"
export * from "./ModalAddSaillieBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports